/* ─────────────────────────────────────────────────────────────────────────
   黑五页的交互：首屏的雪和状态、倒计时、底部托盘、身高尺、擦玻璃、收尾雪堆。
   雪的引擎在 eb-snow.js，必须先加载（各 section 里的 script 顺序保证了这一点）。

   每个 bf section 都会引一次这个文件，同一个 src 浏览器会执行多次，
   所以开头有加载守卫；初始化按元素打标记，编辑器里重载 section 时只补新的。
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.ebBlackFridayLoaded) return;
  window.ebBlackFridayLoaded = true;

  var pad = function (n) { return String(n).padStart(2, '0'); };
  var once = function (el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  };

  /* ── 倒计时 ─────────────────────────────────────────────────────────────
     数字只在前端算：服务端渲染的数字被缓存多久就错多久。
     到点时：进行中 → 通知全页「结束了」；未开始 → 刷新一次进入进行中。
     开始那一刻不在前端切换文案，原因同 campaign-offer：结束文案已经在
     页面里，脚本切错一次就是把「已结束」展示给正在买的人。 */
  function countdown(el) {
    var until = Date.parse(el.getAttribute('data-until'));
    if (isNaN(until)) return;
    var cells = el.querySelectorAll('[data-bf-cell]');
    var flat = el.querySelector('[data-bf-flat]');
    var phase = el.getAttribute('data-phase');
    var timer;
    function tick() {
      var s = Math.floor((until - Date.now()) / 1000);
      if (s <= 0) {
        clearInterval(timer);
        s = 0;
        if (phase === 'soon') {
          if (!sessionStorage.getItem('eb-bf-reloaded')) {
            try { sessionStorage.setItem('eb-bf-reloaded', '1'); } catch (e) {}
            setTimeout(function () { location.reload(); }, 1500);
          }
        } else {
          document.dispatchEvent(new CustomEvent('eb:bf:over'));
        }
      }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      if (cells.length === 4) {
        cells[0].textContent = pad(d); cells[1].textContent = pad(h);
        cells[2].textContent = pad(m); cells[3].textContent = pad(sec);
      }
      if (flat) flat.textContent = d + (flat.getAttribute('data-d') || 'd') + ' ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
      /* 不到一天时变色提醒，颜色用 warning 语义，不在这里写死 */
      el.classList.toggle('is-urgent', s > 0 && s < 86400);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ── 首屏 ───────────────────────────────────────────────────────────── */
  function hero(el) {
    var Snow = window.EbSnow;
    var state = el.getAttribute('data-state');
    var section = el.closest('.eb-section') || el;
    var letters = el.querySelectorAll('[data-bf-letter]');
    var snow = null;
    if (Snow && state !== 'over') {
      snow = new Snow(el, {
        back: el.querySelector('[data-bf-snow-back]'),
        front: el.querySelector('[data-bf-snow-front]'),
        letters: el.getAttribute('data-settle') === 'true' ? letters : null,
        density: density(el)
      });
      var hint = el.querySelector('[data-bf-hint]'), ht;
      snow.onInteract = function () {
        if (!hint) return;
        clearTimeout(ht);
        ht = setTimeout(function () { hint.classList.add('is-gone'); }, 2500);
      };
    }
    /* 结束时：雪停、积雪化掉，底色回到浅色——和刷新后服务端渲染的结束态一致 */
    document.addEventListener('eb:bf:over', function () {
      el.classList.add('is-over');
      section.classList.remove('scheme-inverse', 'eb-field-ink');
      section.classList.add('scheme-bone');
      if (snow) snow.melting = true;
    });
  }

  /* 没开始时雪很少，越临近越密：期待感是一点点攒起来的 */
  function density(el) {
    var base = (parseFloat(el.getAttribute('data-density')) || 100) / 100;
    if (el.getAttribute('data-state') !== 'soon') return base;
    var opens = Date.parse(el.getAttribute('data-opens'));
    if (isNaN(opens)) return base * 0.3;
    var days = (opens - Date.now()) / 864e5;
    return base * (days > 7 ? 0.22 : days > 1 ? 0.45 : 0.7);
  }

  /* ── 收尾段：雪堆 ──────────────────────────────────────────────────── */
  function lastcall(el) {
    var state = el.getAttribute('data-state');
    var effect = el.getAttribute('data-effect') || 'snow';
    if (effect === 'none') return;
    /* 春季：花瓣零星落在地上，过一会儿褪掉，不堆成一堆 */
    if (effect === 'petals') {
      if (!window.EbPetals || state === 'over') return;
      var petals = new window.EbPetals(el, { back: el.querySelector('[data-bf-pile]'), ground: true, density: state === 'live' ? 0.6 : 0.3 });
      document.addEventListener('eb:bf:over', function () { petals.stop(); el.classList.add('is-over'); });
      return;
    }
    var Snow = window.EbSnow;
    if (!Snow) return;
    var snow = new Snow(el, {
      back: el.querySelector('[data-bf-pile]'),
      pile: true,
      density: state === 'live' ? 0.8 : state === 'soon' ? 0.25 : 0
    });
    if (state === 'over') snow.melting = true;
    document.addEventListener('eb:bf:over', function () {
      snow.melting = true;
      el.classList.add('is-over');
    });
  }

  /* ── 底部托盘 ─────────────────────────────────────────────────────────
     搬到 body 下：祖先只要有 transform / filter（编辑器、插件的包裹层都可能有），
     position:fixed 就会变成相对那个祖先。首屏和收尾段在视口里时它自己藏起来，
     这两段已经有大倒计时了，同屏出现两个是噪音。 */
  function dock(el) {
    /* 编辑器重载首屏时，上一次搬到 body 的那个还在，先清掉 */
    document.querySelectorAll('[data-bf-dock]').forEach(function (old) {
      if (old !== el && old.id === el.id) old.remove();
    });
    document.body.appendChild(el);
    var hiders = document.querySelectorAll('[data-bf-hides-dock]');
    var seen = new Map();
    function sync() {
      var any = false;
      seen.forEach(function (v) { if (v) any = true; });
      el.classList.toggle('is-on', !any);
      el.setAttribute('aria-hidden', any ? 'true' : 'false');
    }
    if (!hiders.length) { sync(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      sync();
    }, { threshold: 0.05 });
    hiders.forEach(function (h) { seen.set(h, true); io.observe(h); });
    document.addEventListener('eb:bf:over', function () { el.hidden = true; });
  }

  /* ── 身高尺 ───────────────────────────────────────────────────────────
     车型卡片全部在服务端渲染好，这里只藏不删：没有脚本时所有车型都在，
     各自写着适合的身高区间，一样能自己判断。 */
  function fit(el) {
    var track = el.querySelector('[data-bf-track]');
    var thumb = el.querySelector('[data-bf-thumb]');
    var out = el.querySelector('[data-bf-height]');
    var note = el.querySelector('[data-bf-note]');
    var ask = el.querySelector('[data-bf-ask]');
    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-bf-model]'));
    var bands = el.querySelectorAll('[data-bf-band]');
    var lo = +el.getAttribute('data-lo'), hi = +el.getAttribute('data-hi');
    var marginLo = +el.getAttribute('data-margin-lo') || 0;
    var marginHi = +el.getAttribute('data-margin-hi') || 0;
    var unit = el.getAttribute('data-unit') || 'cm';
    var t = {
      overlap: el.getAttribute('data-t-overlap') || '',
      edge: el.getAttribute('data-t-edge') || '',
      none: el.getAttribute('data-t-none') || ''
    };
    var models = cards.map(function (c) {
      return { el: c, min: +c.getAttribute('data-min'), max: +c.getAttribute('data-max'), name: c.getAttribute('data-name') };
    });
    var h = +el.getAttribute('data-start') || lo;
    el.classList.add('is-live');

    function fill(tpl, map) {
      return String(tpl).replace(/%(\w+)%/g, function (_, k) { return map[k] == null ? '' : map[k]; });
    }

    function set(v) {
      h = Math.max(lo, Math.min(hi, Math.round(v)));
      var pct = (h - lo) / (hi - lo) * 100;
      out.textContent = h;
      thumb.style.left = pct + '%';
      thumb.setAttribute('aria-valuenow', h);
      thumb.setAttribute('aria-valuetext', h + ' ' + unit);

      var fits = models.filter(function (m) { return h >= m.min && h <= m.max; });
      var msg = '', near = null;
      if (fits.length > 1) {
        msg = fill(t.overlap, { h: h, count: fits.length });
      } else if (!fits.length) {
        var best = Infinity;
        models.forEach(function (m) {
          var below = h < m.min, d = below ? m.min - h : h - m.max;
          if (d <= (below ? marginLo : marginHi) && d < best) { best = d; near = m; }
        });
        if (near) {
          fits = [near];
          msg = fill(t.edge, { h: h, model: near.name, min: near.min, max: near.max });
        } else {
          msg = fill(t.none, { h: h });
        }
      }
      models.forEach(function (m) { m.el.hidden = fits.indexOf(m) < 0; });
      bands.forEach(function (b) {
        b.classList.toggle('is-dim', fits.length > 0 && !fits.some(function (m) { return m.el.getAttribute('data-key') === b.getAttribute('data-key'); }));
      });
      note.hidden = !msg;
      if (msg) note.innerHTML = msg;
      if (ask) ask.hidden = fits.length > 0;
    }

    function fromX(x) {
      var r = track.getBoundingClientRect();
      return lo + (x - r.left) / r.width * (hi - lo);
    }
    var drag = false;
    track.addEventListener('pointerdown', function (e) {
      drag = true;
      track.setPointerCapture(e.pointerId);
      set(fromX(e.clientX));
      thumb.focus({ preventScroll: true });
    });
    track.addEventListener('pointermove', function (e) { if (drag) set(fromX(e.clientX)); });
    track.addEventListener('pointerup', function () { drag = false; });
    track.addEventListener('pointercancel', function () { drag = false; });
    thumb.addEventListener('keydown', function (e) {
      var step = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1, PageDown: -5, PageUp: 5 }[e.key];
      if (step) { e.preventDefault(); set(h + step); }
      if (e.key === 'Home') { e.preventDefault(); set(lo); }
      if (e.key === 'End') { e.preventDefault(); set(hi); }
    });
    el.querySelectorAll('[data-bf-step]').forEach(function (b) {
      b.addEventListener('click', function () { set(h + (+b.getAttribute('data-bf-step'))); });
    });
    set(h);
  }

  /* ── 擦玻璃 ───────────────────────────────────────────────────────────
     玻璃是一张画布盖在内容上，内容一直在 DOM 里（画布 aria-hidden）。
     停手 2 秒雾会慢慢回来；擦开过半就整块化掉，不再回来。
     手机上走 touchmove（passive）：竖着滑页面经过玻璃也能擦开，不拦滚动。 */
  function frost(el) {
    var canvas = el.querySelector('[data-bf-glass]');
    var ring = el.querySelector('[data-bf-ring]');
    var btn = el.closest('.eb-section').querySelector('[data-bf-clear]');
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var ctx = canvas.getContext('2d');
    var reduce = window.EbSnow ? window.EbSnow.reduced : false;
    var tex, mask, mctx, w, h, lp = null, last = 0, cleared = false;
    var touch = window.matchMedia('(hover: none)').matches;
    var label = el.getAttribute(touch ? 'data-t-touch' : 'data-t-mouse') || '';

    function build() {
      var r = el.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = Math.round(w * DPR); canvas.height = Math.round(h * DPR);
      tex = document.createElement('canvas');
      tex.width = canvas.width; tex.height = canvas.height;
      var t = tex.getContext('2d');
      t.scale(DPR, DPR);
      var g = t.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, 'rgba(226,236,245,.93)');
      g.addColorStop(1, 'rgba(196,216,234,.9)');
      t.fillStyle = g;
      t.fillRect(0, 0, w, h);
      for (var i = 0; i < w * h / 90; i++) {
        t.fillStyle = 'rgba(255,255,255,' + Math.random() * 0.35 + ')';
        var s = Math.random() * 2.2;
        t.fillRect(Math.random() * w, Math.random() * h, s, s);
      }
      /* 冰花从两侧边缘长进来 */
      t.strokeStyle = 'rgba(255,255,255,.38)';
      t.lineCap = 'round';
      function fern(x, y, a, len, d) {
        if (d > 5 || len < 4) return;
        var x2 = x + Math.cos(a) * len, y2 = y + Math.sin(a) * len;
        t.lineWidth = Math.max(0.5, 2.2 - d * 0.4);
        t.beginPath(); t.moveTo(x, y); t.lineTo(x2, y2); t.stroke();
        for (var k = 1; k <= 3; k++) {
          var px = x + (x2 - x) * k / 4, py = y + (y2 - y) * k / 4;
          fern(px, py, a + 0.75, len * 0.42, d + 1);
          fern(px, py, a - 0.75, len * 0.42, d + 1);
        }
        fern(x2, y2, a + (Math.random() - 0.5) * 0.4, len * 0.7, d + 1);
      }
      for (var f = 0, n = Math.max(3, Math.round(w / 95)); f < n; f++) {
        fern(0, h * Math.random(), (Math.random() - 0.5) * 0.9, 50 + Math.random() * 60, 0);
        fern(w, h * Math.random(), Math.PI + (Math.random() - 0.5) * 0.9, 50 + Math.random() * 60, 0);
      }
      if (label) {
        var mono = getComputedStyle(document.documentElement).getPropertyValue('--font-mono') || 'monospace';
        t.fillStyle = 'rgba(20,46,67,.55)';
        t.font = '500 11px ' + mono;
        t.textAlign = 'center';
        t.fillText(label.toUpperCase(), w / 2, h / 2);
      }
      mask = document.createElement('canvas');
      mask.width = canvas.width; mask.height = canvas.height;
      mctx = mask.getContext('2d');
      mctx.scale(DPR, DPR);
      mctx.fillStyle = '#000';
      mctx.fillRect(0, 0, w, h);
      draw();
    }
    function draw() {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(tex, 0, 0);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
    }
    function wipe(x, y) {
      if (cleared || !mctx) return;
      var r = el.getBoundingClientRect();
      x -= r.left; y -= r.top;
      mctx.globalCompositeOperation = 'destination-out';
      var steps = lp ? Math.ceil(Math.hypot(x - lp.x, y - lp.y) / 8) : 1;
      for (var i = 0; i < steps; i++) {
        var px = lp ? lp.x + (x - lp.x) * i / steps : x;
        var py = lp ? lp.y + (y - lp.y) * i / steps : y;
        var g = mctx.createRadialGradient(px, py, 0, px, py, 44);
        g.addColorStop(0, 'rgba(0,0,0,.9)');
        g.addColorStop(0.6, 'rgba(0,0,0,.5)');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        mctx.fillStyle = g;
        mctx.fillRect(px - 44, py - 44, 88, 88);
      }
      mctx.globalCompositeOperation = 'source-over';
      lp = { x: x, y: y };
      last = performance.now();
      draw();
    }
    function coverage() {
      var s = document.createElement('canvas');
      s.width = 40; s.height = 24;
      var c = s.getContext('2d');
      c.drawImage(mask, 0, 0, 40, 24);
      var d = c.getImageData(0, 0, 40, 24).data, a = 0;
      for (var i = 3; i < d.length; i += 4) a += d[i];
      return a / (255 * 960);
    }
    function clear() {
      cleared = true;
      el.classList.add('is-clear');
      if (ring) ring.style.opacity = 0;
    }

    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = el.getBoundingClientRect();
      if (ring) {
        ring.style.left = (e.clientX - r.left) + 'px';
        ring.style.top = (e.clientY - r.top) + 'px';
        ring.style.opacity = cleared ? 0 : 1;
      }
      wipe(e.clientX, e.clientY);
    });
    el.addEventListener('pointerleave', function () { if (ring) ring.style.opacity = 0; lp = null; });
    el.addEventListener('touchstart', function (e) { lp = null; wipe(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    el.addEventListener('touchmove', function (e) { wipe(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    el.addEventListener('touchend', function () { lp = null; }, { passive: true });
    if (btn) btn.addEventListener('click', clear);

    if (reduce) { clear(); return; }
    el.classList.add('is-frosted');
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build); else build();
    var rt;
    window.addEventListener('resize', function () {
      if (cleared) return;
      clearTimeout(rt);
      rt = setTimeout(build, 150);
    });
    setInterval(function () {
      if (cleared || !mctx) return;
      if (coverage() < 0.45) { clear(); return; }
      if (performance.now() - last > 2000) {
        mctx.globalAlpha = 0.035;
        mctx.fillStyle = '#000';
        mctx.fillRect(0, 0, w, h);
        mctx.globalAlpha = 1;
        draw();
      }
    }, 300);
  }

  /* ── 整页：从夜到冰（首屏设置 The rest of the page） ─────────────────
     设计稿 references/black-friday/page-ground.md。首屏以下的 section 去掉各自的底色，
     共用 <main> 上的一条渐变：深色 section 依次走主色 900 → 600，浅色 section 走 200 →
     偏 100 的冰蓝，不到白——到白雪就看不见了。深浅交界的那一下只放在两个 section 的
     上下留白里（各 70px 以内），字永远不会落在半深不浅的颜色上。
     哪个 section 是深是浅，看它自己配色方案的字色，不用另外设置。
     没有脚本时什么都不变：每个 section 还是自己的底色。 */
  function ground(hero) {
    var mode = hero.getAttribute('data-bf-ground');
    if (!mode || mode === 'off') return;
    var main = hero.closest('main');
    var own = hero.closest('.shopify-section');
    if (!main || !own) return;
    main.classList.add('eb-bfground');
    own.classList.add('eb-bf-keep');

    var DARK = ['900', '800', '700', '600'];
    function lum(c) {
      var m = c.match(/[\d.]+/g);
      if (!m) return 0;
      return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
    }
    function darkAt(t) {
      /* t 在 0..1 之间，在四档之间混色，section 再多也是平滑的一条 */
      var x = Math.max(0, Math.min(1, t)) * (DARK.length - 1), i = Math.min(DARK.length - 2, Math.floor(x));
      var k = Math.round((x - i) * 100);
      return 'color-mix(in srgb,var(--accent-' + DARK[i + 1] + ') ' + k + '%,var(--accent-' + DARK[i] + '))';
    }
    function lightAt(t) {
      return 'color-mix(in srgb,var(--accent-100) ' + Math.round(Math.max(0, Math.min(1, t)) * 45) + '%,var(--accent-200))';
    }

    var lightTop = Infinity;
    function paint() {
      var mr = main.getBoundingClientRect();
      var list = [];
      var after = false;
      Array.prototype.forEach.call(main.children, function (w) {
        if (w === own) { after = true; return; }
        if (!after || !w.classList.contains('shopify-section')) return;
        var sec = w.querySelector('.eb-section');
        var r = w.getBoundingClientRect();
        if (!sec || r.height < 1) return;
        var dark = lum(getComputedStyle(sec).color) > 0.5;
        w.classList.toggle('is-bf-dark', dark);
        w.classList.toggle('is-bf-light', !dark);
        var cs = getComputedStyle(sec);
        list.push({ dark: dark, top: r.top - mr.top, bot: r.bottom - mr.top,
          padT: parseFloat(cs.paddingTop) || 0, padB: parseFloat(cs.paddingBottom) || 0 });
      });
      if (!list.length) return;
      var nd = list.filter(function (x) { return x.dark; }).length;
      var nl = list.length - nd, di = 0, li = 0;
      list.forEach(function (x) {
        if (x.dark) { x.c0 = darkAt(di / nd); x.c1 = darkAt((di + 1) / nd); di++; }
        else { x.c0 = lightAt(li / nl); x.c1 = lightAt((li + 1) / nl); li++; }
      });
      var stops = ['transparent 0px', 'transparent ' + Math.round(list[0].top) + 'px'];
      lightTop = Infinity;
      list.forEach(function (x, i) {
        var prev = list[i - 1], next = list[i + 1];
        var a = x.top, b = x.bot;
        if (prev && prev.dark !== x.dark) a += Math.min(70, x.padT);
        if (next && next.dark !== x.dark) b -= Math.min(70, x.padB);
        stops.push(x.c0 + ' ' + Math.round(a) + 'px', x.c1 + ' ' + Math.round(b) + 'px');
        if (!x.dark && lightTop === Infinity) lightTop = x.top;
      });
      main.style.setProperty('--bf-ground', 'linear-gradient(180deg,' + stops.join(',') + ')');
    }
    paint();
    var pt;
    var again = function () { clearTimeout(pt); pt = setTimeout(paint, 120); };
    if (window.ResizeObserver) new ResizeObserver(again).observe(main);
    window.addEventListener('load', paint);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);

    /* 整页的雪：一层固定在视口上的画布，压在内容下面、底色上面——卡片和文字挡住它，
       留白里看得见。不理鼠标（交互留给首屏和收尾段）。首屏还在视口里时停帧，
       那里已经有首屏自己的雪了。 */
    var Snow = window.EbSnow;
    if (!Snow) return;
    var sky = document.createElement('div');
    sky.className = 'eb-bfsky';
    sky.setAttribute('aria-hidden', 'true');
    var canvas = document.createElement('canvas');
    sky.appendChild(canvas);
    main.insertBefore(sky, main.firstChild);
    var d = (parseInt(hero.getAttribute('data-density'), 10) || 100) / 100;
    var snow = new Snow(sky, {
      back: canvas,
      interactive: false,
      density: (hero.getAttribute('data-state') === 'soon' ? 0.3 : 0.5) * d,
      halo: function () { return lightTop + main.getBoundingClientRect().top; }
    });
    new IntersectionObserver(function (es) {
      var heroUp = es[0].intersectionRatio > 0.6;
      snow.visible = !heroUp;
      sky.classList.toggle('is-resting', heroUp);
      if (!heroUp) snow.start();
    }, { threshold: [0, 0.6, 1] }).observe(hero);
    document.addEventListener('eb:bf:over', function () { snow.melting = true; });
  }

  /* ── 产品卡上沿的积雪 ─────────────────────────────────────────────
     卡片自己 overflow:hidden（圆角要裁照片），雪放进去会压到照片，所以雪放在卡片外面，
     摆在每张卡的上沿，最厚 14px、大半在卡外，约 20 秒积满。
     电脑：鼠标进卡片，卡片耸一下，雪滑下去散开，从零再积。
     手机：没有悬停——卡片停在屏幕中间那一刻抖一次，点卡片（按钮以外）也抖。

     踩过的坑（2026-11-03 第一版）：用 getBoundingClientRect 量卡片位置，量到的是入场
     动画半路的位置——卡片自己带 data-reveal="rise"，没进视口时一直往下偏 24px，雪就
     压在照片上。现在：
       · 雪放进卡片的父元素（网格那一层），网格的入场位移两者一起吃；
       · 位置用 offsetLeft / offsetTop，不受 transform 影响；
       · 卡片自己的位移和透明度逐帧照抄到雪的外层（见 follow）；生长、抖落放在里层，
         不和它抢 transform。
     还有一个：雪檐原来按 400px 画好再拉伸，在一张 1400px 的大卡上起伏被拉平成一道白线。
     现在按卡片实际宽度画，起伏间距固定 40px 左右。 */
  function caps(hero) {
    if (hero.getAttribute('data-bf-caps') !== 'on') return;
    var reduce = window.EbSnow ? window.EbSnow.reduced : false;
    var main = hero.closest('main');
    if (!main) return;
    var items = [];

    function shape(w) {
      var n = Math.max(4, Math.round(w / 40)), pts = [];
      for (var i = 0; i <= n; i++) {
        var x = Math.round(i / n * w);
        var y = (i === 0 || i === n) ? 15 : Math.round(3 + Math.random() * 7);
        pts.push(x + ' ' + y);
      }
      return '<svg viewBox="0 0 ' + w + ' 22" preserveAspectRatio="none"><path d="M0 22L' +
        pts.join('L') + 'L' + w + ' 22Z"/></svg>';
    }

    function place(it) {
      var c = it.card, w = c.offsetWidth + 6;
      it.cap.style.left = (c.offsetLeft - 3) + 'px';
      it.cap.style.top = (c.offsetTop - 10) + 'px';
      it.cap.style.width = w + 'px';
      if (Math.abs((it.w || 0) - w) > 2) { it.w = w; it.snow.innerHTML = shape(w); }
    }

    /* class 变了之后的 1.6 秒里逐帧照抄（入场的延迟 + 过渡时长都在这之内），之后不再跑 */
    function follow(it) {
      it.until = performance.now() + 1600;
      if (it.loop) return;
      it.loop = true;
      (function frame() {
        var cs = getComputedStyle(it.card);
        it.cap.style.transform = cs.transform === 'none' ? '' : cs.transform;
        it.cap.style.opacity = cs.opacity;
        if (performance.now() < it.until) requestAnimationFrame(frame);
        else it.loop = false;
      })();
    }

    function build() {
      items.forEach(function (it) { if (it.mo) it.mo.disconnect(); it.cap.remove(); });
      items = [];
      main.querySelectorAll('[data-eb-pcard]').forEach(function (card) {
        var box = card.parentElement;
        if (!box) return;
        if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
        var cap = document.createElement('span');
        cap.className = 'eb-bfcap';
        cap.setAttribute('aria-hidden', 'true');
        var snow = document.createElement('span');
        snow.className = 'eb-bfcap__snow';
        cap.appendChild(snow);
        var it = { card: card, cap: cap, snow: snow };
        /* 雪照抄卡片当下的样子：卡片怎么位移、透明度多少，雪就怎么位移、透明度多少。
           卡片在不同情况下动法不一样——电脑上入场只淡入、触屏上会上浮 24px、滑出视口
           会重新藏起来、悬停会上抬——按规则猜总会漏一种，所以直接看它。 */
        it.mo = new MutationObserver(function () { follow(it); });
        it.mo.observe(card, { attributes: true, attributeFilter: ['class'] });
        card.addEventListener('pointerenter', function () { follow(it); });
        card.addEventListener('pointerleave', function () { follow(it); });
        box.appendChild(cap);
        place(it);
        follow(it);
        items.push(it);
        if (!reduce) bind(it);
      });
    }

    function shake(it) {
      if (it.busy) return;
      it.busy = true;
      it.card.classList.remove('is-bf-shrug');
      void it.card.offsetWidth;
      it.card.classList.add('is-bf-shrug');
      it.snow.classList.add('is-falling');
      var w = it.w || 200;
      for (var i = 0; i < 7; i++) {
        var p = document.createElement('i');
        p.className = 'eb-bfpuff';
        p.style.left = (10 + Math.random() * (w - 20)) + 'px';
        p.style.setProperty('--dx', Math.round((Math.random() - 0.5) * 40) + 'px');
        p.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
        it.cap.appendChild(p);
        setTimeout(function (el) { el.remove(); }.bind(null, p), 1400);
      }
      setTimeout(function () {
        /* 从零重新积：换一个动画名才会从头播 */
        it.snow.classList.remove('is-falling', 'is-regrow');
        void it.snow.offsetWidth;
        it.snow.classList.add('is-regrow');
        it.card.classList.remove('is-bf-shrug');
        it.busy = false;
      }, 1000);
    }

    var touch = window.matchMedia('(hover: none)').matches;
    var io = touch ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var it = items.filter(function (x) { return x.card === e.target; })[0];
        if (it && !it.seen) { it.seen = true; setTimeout(function () { shake(it); }, 350); }
      });
    }, { rootMargin: '-42% 0px -42% 0px' }) : null;

    function bind(it) {
      it.card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') shake(it); });
      it.card.addEventListener('click', function (e) {
        if (e.pointerType === 'mouse') return;
        if (e.target.closest('a,button,input,select,label')) return;
        shake(it);
      });
      if (io) io.observe(it.card);
    }

    build();
    var pt;
    var again = function () { clearTimeout(pt); pt = setTimeout(function () { items.forEach(place); }, 100); };
    window.addEventListener('resize', again);
    window.addEventListener('load', again);
    if (window.ResizeObserver) new ResizeObserver(again).observe(main);
    /* 编辑器里改了产品、换了卡片样式，section 会整块重画，旧的雪跟着没了，重新挂 */
    document.addEventListener('shopify:section:load', function () { setTimeout(build, 50); });
  }

  function init(scope) {
    var root = scope || document;
    var run = function (sel, key, fn) {
      root.querySelectorAll(sel).forEach(function (el) { if (once(el, key)) fn(el); });
    };
    run('[data-bf-count]', 'bfCountReady', countdown);
    run('[data-bf-hero]', 'bfHeroReady', hero);
    run('[data-bf-hero]', 'bfGroundReady', ground);
    run('[data-bf-hero]', 'bfCapsReady', caps);
    run('[data-bf-last]', 'bfLastReady', lastcall);
    run('[data-bf-fit]', 'bfFitReady', fit);
    run('[data-bf-frost]', 'bfFrostReady', frost);
    run('[data-bf-dock]', 'bfDockReady', dock);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
